import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/components/common/CommunitySection.jsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/components/common/whatsapp.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/components/courses/course-features/CourseFeatureSection.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/components/courses/courses/FreeCourses.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/components/courses/hero/HeroSection.jsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/node_modules/next/dist/client/script.js");
